import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Button } from '@driftt/dds'
import { Div, Input, Modal } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'

import { getOrgProperties, deleteSecondaryOwnerProp, setSecondaryOwnerProp } from 'api/settings'

import './style.css'

export default ({
  onClose,
  showTransientNotification
}) => {

  const { id: orgId } = useSelector(state => state.org)
  const { account: accountProperties } = useSelector(state => state.properties)
  const [ properties, setProperties ] = useState({})
  const { secondaryAccountOwnerField: originalSecondaryOwnerField } = properties
  const [ secondaryAccountOwnerField, setSecondaryAccountOwnerField ] = useState("")
  const [ notifySecondaryOwner, setNotifySecondaryOwner ] = useState(false)
  const [ isSaving, setIsSaving ] = useState(false)

  useEffect(() => {
    getOrgProperties()
      .then(({ data }) => {
        setProperties(data)
        setSecondaryAccountOwnerField(data.secondaryAccountOwnerField)
        setNotifySecondaryOwner(!!data.secondaryAccountOwnerField)
      })
  }, [])

  const saveAccountSettings = () => {
    const handleError = (e) => {
      console.error(e)
      showTransientNotification({ type: 'error', message: 'We had a problem saving your account settings.'})
    }
    const saveHandler = () => notifySecondaryOwner ?
      setSecondaryOwnerProp({ orgId, secondaryAccountOwnerField }) :
      deleteSecondaryOwnerProp({ orgId })
    setIsSaving(true)
    saveHandler()
      .then(() => showTransientNotification({ type: 'success', message: 'Your settings have been updated.'}))
      .catch(handleError)
      .finally(() => {
        setIsSaving(false)
        onClose()
      })
  }

  const saveIsDisabled = () => {
    return (notifySecondaryOwner && !secondaryAccountOwnerField) ||                         //no option selected
      (!notifySecondaryOwner && !originalSecondaryOwnerField) ||                            //no change
      (notifySecondaryOwner && originalSecondaryOwnerField === secondaryAccountOwnerField)  //no change
  }

  return <Modal
    title="Account settings"
    open={true}
    onClose={onClose}
    size="small">
      <Div className="accounts-secondary-owner-settings-modal-top">
        <Input
          className="accounts-secondary-owner-settings-modal-checkbox"
          type="checkbox"
          checked={notifySecondaryOwner}
          onChange={() => setNotifySecondaryOwner(!notifySecondaryOwner)}
          label="Notify secondary owners in addition to the primary owner when accounts are online"
        />
        { notifySecondaryOwner && <Div className="accounts-secondary-owner-settings-modal-select-container">
          <Select 
            placeholderText="Select or search..."
            label="Field name"
            value={{label: secondaryAccountOwnerField, value: secondaryAccountOwnerField}}
            options={accountProperties && accountProperties.filter(prop => prop.type === 'TEAMMEMBER').map(prop => ({label: prop.label, value: prop.label}))}
            onChange={({ value }) => setSecondaryAccountOwnerField(value)}
            maxMenuHeight={100}
          />
        </Div>}
      </Div>
      <Div className="accounts-secondary-owner-settings-modal-bottom">
        <Button
          onClick={saveAccountSettings}
          disabled={saveIsDisabled()}
          loading={isSaving}>
          Save
        </Button>
        <Button variant="secondary" onClick={onClose} className="accounts-secondary-owner-settings-cancel-button">
          Cancel
        </Button>
      </Div>
  </Modal>
}